import { render, staticRenderFns } from "./edit-tag-filter.vue?vue&type=template&id=fcc45b3a&scoped=true&"
import script from "./edit-tag-filter.vue?vue&type=script&lang=js&"
export * from "./edit-tag-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc45b3a",
  null
  
)

export default component.exports